import { EllipsisOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import BrandsApi from "../../../api/BrandsApi";
import AccountsApi from "../../../api/AccountsApi";
import { BrandDto } from "../../../generated/account-client";
import { memberState } from "../../../state/atoms";
import { success } from "../../../service/MessageService";
import "./BrandsPage.scss";
import { getImagePath } from "../../../util/utils";
import { useNavigate } from "react-router-dom";
import { MemberDtoPlanEnum } from "../../../generated/dashboard-client";
import { env } from "../../../env/env";
import { Skeleton } from "antd";

export function BrandsPage() {
  const [member] = useRecoilState(memberState);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [brands, setBrands] = useState([] as BrandDto[]);

  useEffect(() => {
    setLoading(true);

    AccountsApi.getUserBrands(member.id)
      .then((resp) => {
        setBrands(resp.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [member.id]);

  function addNewBrand() {
    if (member.plan === MemberDtoPlanEnum.Free) {
      window.MHM.ProModal.upgrade({memberId: member.id, onSuccess: () => window.location.reload()});
      return;
    }

    setLoading(true);
    BrandsApi.createBrand({ memberId: member.id, draft: true })
      .then((resp) => {
        let brand = resp.data;
        navigate(env.dashboardPath + `/account/brands/${brand.id}`);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  function onEdit(brand: BrandDto) {
    navigate(env.dashboardPath + `/account/brands/${brand.id}`);
  }

  function onDelete(brand: BrandDto) {
    BrandsApi.deleteBrand(brand.id || "-1")
      .then((data) => {
        console.log("data", data);
        success("Brand removed!");
        navigate(env.dashboardPath + `/account/brands`);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  return (
    <div className={"content brands-page"}>
      <h3>Brands</h3>
      <p>
        Create and manage your brands to stay organized and make the design
        process more efficient
      </p>

      {loading && <Skeleton />}

      {!loading && (
        <>
          <section className={"brands"}>
            <div className={"add-new"} onClick={addNewBrand}>
              +
            </div>

            {brands.map((it) => (
              <div className={"brand-card"} key={it.id}>
                <div className={"options-dropdown"}>
                  <EllipsisOutlined />
                </div>

                <ul className={"options"}>
                  <li onClick={() => onEdit(it)}>Edit Brand</li>
                  <li>Display Settings</li>
                  <li onClick={() => onDelete(it)}>Delete Brand</li>
                </ul>

                <div className={"logo"}>
                  <img
                    loading="lazy"
                    src={getImagePath(it.logos?.at(0)?.path || "")}
                    alt={""}
                  />
                </div>
                <h4 className={"title"}>{it.name}</h4>
              </div>
              // <BrandCard
              //   key={it.id}
              //   location={it}
              //   onEdit={onEdit}
              //   onRemove={onRemove}
              //   disableRemove={idx === 0}
              // />
            ))}
          </section>
        </>
      )}
    </div>
  );
}
